import { CREATE_CONTACT_ADD_TO_LIST, CREATE_CONTACT_ADD_TO_LIST_SUCCESS, CREATE_CONTACT_ADD_TO_LIST_FAILURE, CLEAR_ACTIVECAMPAIGN,
  CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER, CREATE_CONTACT_ADD_TO_LIST_SUCCESS_FROM_FOOTER, CREATE_CONTACT_ADD_TO_LIST_FAILURE_FROM_FOOTER} from '../types';

const initialState = {
  status: 'initial',
  error: null,
  footerStatus: 'initial',
  footerError: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case CREATE_CONTACT_ADD_TO_LIST:
      return {
        ...state,
        status: 'fetching',
        error: null
      };
    case CREATE_CONTACT_ADD_TO_LIST_SUCCESS:
      return {
        ...state,
        status: 'success',
      };
    case CREATE_CONTACT_ADD_TO_LIST_FAILURE:
    const {error} = action
      return {
        ...state,
        status: 'failure',
        error: error.title
      };
    case CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER:
      return {
        ...state,
        footerStatus: 'fetching',
        footerError: null
      };
    case CREATE_CONTACT_ADD_TO_LIST_SUCCESS_FROM_FOOTER:
      return {
        ...state,
        footerStatus: 'success',
      };
    case CREATE_CONTACT_ADD_TO_LIST_FAILURE_FROM_FOOTER:
      return {
        ...state,
        footerStatus: 'failure',
        footerError: action.error.title
      };
    case CLEAR_ACTIVECAMPAIGN:
      return{
        ...initialState
      }
    default:
      return state;
  }
}
